import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-3 shadow bg-white" }
const _hoisted_2 = { class: "p-grid p-px-4" }
const _hoisted_3 = { class: "p-col" }
const _hoisted_4 = { class: "p-d-flex p-jc-between" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, "ราคาสุทธิ", -1)
const _hoisted_6 = { class: "mt-2 p-grid p-px-3" }
const _hoisted_7 = { class: "p-col" }
const _hoisted_8 = { class: "p-col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", null, _toDisplayString(_ctx.$filters.formatNumber(_ctx.transaction.grandTotal)), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_Button, {
            class: "w-100 p-button-outlined",
            label: "ดูสินค้าเพิ่มเติม",
            style: _normalizeStyle({
              color: _ctx.backgroundColor,
              borderColor: _ctx.backgroundColor,
            }),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.getMoreProduct()))
          }, null, 8, ["style"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_Button, {
            class: "w-100",
            label: "ดำเนินการสั่งซื้อ",
            disabled: 
              _ctx.isDisableForFreeProduct || _ctx.transaction.products.length == 0
            ,
            style: _normalizeStyle({
              backgroundColor: _ctx.backgroundColor,
              borderColor: _ctx.backgroundColor,
            }),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onCheckoutCart()))
          }, null, 8, ["disabled", "style"])
        ])
      ])
    ])
  ]))
}